import { Constants } from '@shared/utils/constants';
export function shouldShowPopUp() {
    return true;
}
/**
 * detemine if app consent modal is a contact form
 *
 * @param appInfo: application info
 * @param ctaType: click-to-action type
 *
 * @return:
 *  true, if application click-to-action is Contact Me, and not a test drive
 *  false, otherwise
 */ export const isAppContactForm = (appInfo, ctaType)=>{
    if (!appInfo) {
        return false;
    }
    if (appInfo.licenseManagement && appInfo.licenseManagement.isMicrosoftManaged) {
        return ctaType === Constants.CTAType.RequestTrial;
    }
    return appInfo.actionString === Constants.ActionStrings.RequestTrial && ctaType !== Constants.CTAType.TestDrive;
};
export function isETERunning(query) {
    return query && !!query[Constants.QueryStrings.ete];
}
